import * as moment from 'moment';
import { GridWrapper, HeaderWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import {
    GridApi, GridReadyEvent, CsvExportParams, ICellRendererParams, ValueGetterParams, FirstDataRenderedEvent,
    IHeaderParams, ColDef, SortChangedEvent, ProcessCellForExportParams, CellClickedEvent, RowDataChangedEvent, GridSizeChangedEvent
} from 'ag-grid-community';
import SortableHeaderComponent from '../admin/center/list/common/sortable-header';
import { Utility } from '@nkr/services/utility';
import { Label } from 'react-bootstrap';
import { IPhlebotRequest } from '@nkr/models/index';
import { PhlebotStatus } from '@nkr/enums/index';
import { useMemo } from 'react';

interface IProps {
    data: IPhlebotRequest[],
    onGridReady: (e: GridReadyEvent) => void,
    onCellClicked: (e: CellClickedEvent) => void
}

const Grid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        props.onGridReady(e);

        // this.setState({
        //     gridApi: e.api
        // });
    };

    const onDataFirstRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onRowDataChanged = (e: RowDataChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const customComparator = (valueA: string, valueB: string) => {
        valueA = valueA ? valueA: "";
        valueB = valueB ? valueB: "";
        return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
      };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        // get the current grids width
        var grid = document.getElementById('grid-wrapper');

        if (grid == null)
            return;

        var gridWidth = grid.offsetWidth;

        // keep track of which columns to hide/show
        var columnsToShow = [];
        var columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        var totalColsWidth = 0;

        var allColumns = e.columnApi.getAllColumns();

        for (var i = 0; i < allColumns.length; i++) {
            var column = allColumns[i];

            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        e.columnApi.setColumnsVisible(columnsToShow, true);
        e.columnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        e.api.sizeColumnsToFit();
    };

    const columns: ColDef[] = [
        {
            colId: '1',
            field: 'rank',
            headerName: 'Rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <div>R#</div>,
            sortable: false,
            width: 50,
            pinned: 'left',
            pinnedRowCellRendererFramework: () => <div></div>,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },

        {
            field: 'id',
            headerName: 'Order #',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Order #</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 70
        },

        {
            field: 'description',
            headerName: 'Description',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Description</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;

                if (data.description.indexOf("Pre-Work Up Lab Kit") > -1)
                    return <Label bsStyle='danger' style={{ fontSize: '100%' }}>{data.description}</Label>
                else if (data.description.indexOf("Home Blood Draw Kit") > -1)
                    return <Label bsStyle='warning' style={{ fontSize: '100%' }}>{data.description}</Label>
                else if (data.description.indexOf("Serology") > -1)

                    return <Label bsStyle='info' style={{ fontSize: '100%' }}>{data.description}</Label>
                else
                    return <Label style={{ fontSize: '100%' }}>{data.description}</Label>
            },
        },

        {
            field: 'vendor',
            headerName: 'Vendor',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Vendor</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;

                if (data.vendor == 0)
                    return <Label bsStyle='danger' style={{ fontSize: '100%' }}>Exam One</Label>
                else
                    return <Label bsStyle='info' style={{ fontSize: '100%' }}>DS2</Label>
            },
        },

        {
            field: 'status',
            headerName: 'Status',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Status</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 275,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;

                if (data.status == PhlebotStatus.CompletedAsScheduled)
                    return <Label bsStyle='success' style={{ fontSize: '100%' }}>Completed</Label>
                else if (data.status == PhlebotStatus.Pending)
                    return <Label bsStyle='danger' style={{ fontSize: '100%' }}>Request Pending</Label>
                else if (PhlebotStatus[data.status].indexOf("Cancelled") > -1)
                    return <Label bsStyle='warning' style={{ fontSize: '100%' }}>{PhlebotStatus[data.status].replace(/([A-Z])/g, ' $1').trim()}</Label>
                else
                    return <Label bsStyle='info' style={{ fontSize: '100%' }}>{PhlebotStatus[data.status].replace(/([A-Z])/g, ' $1').trim()}</Label>
            },
            valueGetter: (props: ValueGetterParams) => {
                let data = props.data as IPhlebotRequest;
                return PhlebotStatus[data.status].replace(/([A-Z])/g, ' $1').trim();
            }
        },
        {
            field: 'alias',
            headerName: 'Alias',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Alias</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100,
        },
        {
            field: 'firstName',
            headerName: 'First Name',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>
                        First Name
                    </HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            comparator: customComparator,
            width: 100
        },

        {
            field: 'lastName',
            headerName: 'Last Name',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>
                        Last Name
                    </HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            comparator: customComparator,
            width: 120
        },
        {
            field: 'email',
            headerName: 'Email',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Email</HeaderWrapper>
                </SortableHeaderComponent>,
            width: 240,
            sortable: true,
            valueGetter: (props: ValueGetterParams) => {
                let data = props.data as IPhlebotRequest;

                if (data.email == null || data.email == '') {
                    return 'N/A';
                }

                return data.email;
            }
        },
        {
            field: 'birthDate',
            headerName: 'Date of Birth',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Birth<br /> Date</HeaderWrapper>
                </SortableHeaderComponent>,
            width: 100,
            sortable: true,
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.birthDate).isValid()
                    ? moment(props.data.birthDate).format('MM/DD/YYYY')
                    : "",
            comparator: Utility.dateComparator
        },
        {
            field: 'phoneNumber',
            headerName: 'Phone Number',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Phone<br /> Number</HeaderWrapper>
                </SortableHeaderComponent>,
            width: 110,
            sortable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;
                return data.phoneNumber;
            },
            valueGetter: (props: ValueGetterParams) =>
                props.data.phoneNumber,
        },
        {
            field: 'dateCreated',
            headerName: 'Request Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Date<br />Requested</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100,
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.dateCreated).format('MM/DD/YY'),
            comparator: Utility.dateComparator,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;
                return <Label bsStyle='primary' style={{ fontSize: '100%' }}>{moment(props.data.dateCreated).format('MM/DD/YY')}</Label>
            },
        },
        {
            field: 'dateScheduled',
            headerName: 'Schedule Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Scheduled<br />Date</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100,
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.dateScheduled).format('MM/DD/YY'),
            comparator: Utility.dateComparator,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;

                if (!moment(data.dateScheduled).isValid())
                    return <Label style={{ fontSize: '100%' }}>Pending</Label>
                else
                    return <Label bsStyle='primary' style={{ fontSize: '100%', backgroundColor: 'deepskyblue' }}>{moment(props.data.dateScheduled).format('MM/DD/YY')}</Label>
            },
        },
        {
            field: 'dateUpdated',
            headerName: 'Updated Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Last<br />Updated</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100,
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.dateUpdated).isValid()
                    ? moment(props.data.dateUpdated).format('MM/DD/YY')
                    : "",
            comparator: Utility.dateComparator,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;

                if (!moment(data.dateUpdated).isValid())
                    return <Label style={{ fontSize: '100%' }}>Pending</Label>
                else
                    return <Label bsStyle='default' style={{ fontSize: '100%' }}>{moment(props.data.dateUpdated).format('MM/DD/YY')}</Label>
            },
        },

        {
            field: 'dateCompleted',
            headerName: 'Completed Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Completed<br />Date</HeaderWrapper>
                </SortableHeaderComponent>,
            sortable: true,
            width: 100,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;

                if (!moment(data.dateCompleted).isValid())
                    return <Label style={{ fontSize: '100%' }}>Pending</Label>
                else
                    return <Label bsStyle='success' style={{ fontSize: '100%' }}>{moment(props.data.dateCompleted).format('MM/DD/YY')}</Label>
            },
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.dateCompleted).isValid()
                    ? moment(props.data.dateCompleted).format('MM/DD/YY')
                    : 'N/A',
            comparator: Utility.dateComparator
        },
        {
            field: 'daysToCompletion',
            headerName: 'Days to Completion',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    <HeaderWrapper>Days to <br />Completion</HeaderWrapper>
                </SortableHeaderComponent>,
            width: 90,
            sortable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IPhlebotRequest;
                if (moment(data.dateCompleted).isValid())
                    return <Label bsStyle="success" style={{ fontSize: '100%' }}>{moment(data.dateCompleted).diff(data.dateCreated, 'days')}</Label>

                return 'N/A';
            },
            valueGetter: (props: ValueGetterParams) =>
                moment(props.data.dateCompleted).isValid()
                    ? moment(props.data.dateCompleted).diff(props.data.dateCreated, 'days')
                    : 'N/A',
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id="grid-wrapper" className='container-fluid-max-sm ag-theme-bootstrap' style={{ height: '67vh' }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={40}
                rowHeight={36}
                enableCellChangeFlash={true}
                suppressCellSelection={true}
                rowStyle={{ cursor: 'pointer' }}
                noRowsOverlayComponentFramework={() => <div>No Phlebotomy Requests found...</div>}
                onGridReady={onGridReady}
                onGridSizeChanged={onGridSizeChanged}
                onFirstDataRendered={onDataFirstRendered}
                onSortChanged={(e: SortChangedEvent) => {
                    e.api.refreshCells();
                }}
                onCellClicked={props.onCellClicked}
                onRowDataChanged={onRowDataChanged}
            />
        </GridWrapper>
    );
}

export default Grid;